import { createEffect } from 'effector'
import { client } from '../../client'
import { type HeaderFxParameter } from '../../index.h'
import { callInitFromParams, throwOvpTransportError } from '../../lib'
import { ModulesTypesEnum, type Modules } from './index.h'

export { ModulesTypesEnum, type Modules }

function isModules(value: unknown): value is Modules {
  return Array.isArray(value)
}

// GET /api/web/modules
export const getModulesFx = createEffect<HeaderFxParameter, Modules, Error>(
  async (params) => {
    const result = await client.get.api.web.modules(callInitFromParams(params))

    if (result.kind === 'success') {
      if (isModules(result.payload)) {
        return result.payload
      }

      return []
    }

    throwOvpTransportError(result)
  }
)
